/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';
    
    import IKitInfo = Models.kitInfo;
    import IPort = Models.Port;
    import IPromise = angular.IPromise;
    import StreamStatusService = Application.Services.StreamStatusService;
    import kitInfo = Application.Models.kitInfo;
    export class DigiconViewerController {
        public static $name: string = "digiconViewerController";
        public static $inject: string[] = ['$scope',
                                           '$q',
                                           'ModalService',
                                           'monitoringRoomService',
                                           'connectionRoomService',
                                           'sonAdapterService',
                                           '$cookies',
                                           '$timeout',
                                           '$document',
                                           '$window',
                                           'stompService',
                                           '$rootScope',
                                           '$location',
                                           'aclService',
                                           'messageTranslationsService',
                                           'userService',
                                           'alarmsService',
                                           'streamPipeService',
                                           'networkNodeService',
                                           'digiconService',
                                           '$interval',
                                           'streamStatusService',
        ];
        public static COOKIE_OPTIONS: ng.cookies.ICookiesOptions = 
                    { expires: Common.Utils.getCookieExpirationDate(), secure:  location.protocol === 'https:' };

        private kiosk: boolean;
        private sonServices: Models.ISwitch[];
        private firstLoad: boolean;
        private loading: boolean = false;
        private plotOptions: jquery.flot.plotOptions;
        private kitsInfo: IKitInfo[];
        public digiconInterval: IPromise<any>;
        private DIGICON_INTERVAL: number = 10000;
        private model = {
            id: 78,
            row: 0,
            column: 0,
            sink: "",
            source: 50,
            type: "Digicon",
            sinkName: "",
            sinkNode: "",
            sourceName: "Kit: 50 - ",
            switchId: "",
            sourceNode: "",
            videoFeed: "",
            content: "",
            links: [
              {
                rel: "monitorPage",
                href: "http://backend:10000/monitorPages/2"
              }
            ]
          }

        constructor(private $scope: ng.IScope,
                    private qService: ng.IQService,
                    private modalService: ngModal.IModalService,
                    private monitoringRoomService: Services.MonitoringRoomService,
                    private connectionRoomService: Services.ConnectionRoomService,
                    private sonService: Services.SonAdapterService,
                    private $cookies: ng.cookies.ICookiesService,
                    private $timeout: ng.ITimeoutService,
                    private $document: ng.IDocumentService,
                    private $window: ng.IWindowService,
                    private stompService: Services.StompService,
                    private $rootScope: Services.IFlexSettings,
                    private $location: ng.ILocationService,
                    private aclService: Services.AclService,
                    private messageTranslationsService: Services.MessageTranslationsService,
                    private userService: Services.UserService,
                    private alarmsService: Services.AlarmsService,
                    private streamPipeService: Services.StreamPipeService,
                    private networkNodeService: Services.NetworkNodeService,
                    private digiconService: Services.DigiconService,
                    private $interval: ng.IIntervalService,
                    private streamStatusService: StreamStatusService,
        ) {
            this.init();
        }

        private async init() {
            this.kitsInfo = await this.digiconService.getKitsInfo().catch( (error) => {
                Common.Utils.alertOnError(error);
                return [];
            });
            this.loading = true;
            this.initData(this.kitsInfo);

            this.$scope.$on("$destroy", () => {
                if (this.digiconInterval !== undefined) {
                    this.$interval.cancel(this.digiconInterval);
                }
            });
        }

        private async initData(kitsInfo: IKitInfo[]): Promise<void> {

            this.digiconInterval = this.$interval(() => {
                kitsInfo.forEach( (k: kitInfo) => {
                    this.streamStatusService.getDigiconParamsData(k.mainKit.id.toString()).then((result: String[]) => {
                        result.forEach((params: any) => {
                            if (params.name === "mainKitRtt") {
                                k.mainKit.rtt = params.lastValue;
                            }
                            if (params.name === "mainKitStatus") {
                                k.mainKit.status = params.lastValue;
                            }
                            if (params.name === "backupKitRtt" && k.backupKit !== null && params.lastValue !== undefined ) {
                                k.backupKit.rtt = params.lastValue;
                            }
                            if (params.name === "backupKitStatus" && k.backupKit !== null && params.lastValue !== undefined) {
                                k.backupKit.status = params.lastValue;
                            }
                        });
                    });
                });
            }, this.DIGICON_INTERVAL);

        }

	// TODO avoid calling this method from HTML
        
    }
}
